import { render, staticRenderFns } from "./SelectConfig.vue?vue&type=template&id=10410f89&scoped=true&"
import script from "./SelectConfig.vue?vue&type=script&lang=js&"
export * from "./SelectConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10410f89",
  null
  
)

export default component.exports